import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import router from "./router.js";
import axios from 'axios'
import axiosCancel from 'axios-cancel-plugin';
import VueAxios from 'vue-axios' //追記
import { library } from '@fortawesome/fontawesome-svg-core'
import {  faQuestionCircle, faFemale, faMale, faTag, faVideo, faCheckCircle, faPaperPlane, faStar, faMedal, faArrowUp, faArrowDown, faExclamation, faArrowLeft, faCrown, faFireAlt, faExternalLinkAlt, faLink, faExternalLinkSquareAlt, faCalendarAlt, faReceipt, faBars, faCaretDown, faMapMarkerAlt, faMoon, faEye, faThumbsUp, faThumbsDown, faLock, faPlay, faUserFriends, faExclamationCircle, faSmile, faFileAlt, faPlus, faTimesCircle, faPlusCircle, faTimes, faUser, faCog, faClone, faEdit, faExclamationTriangle, faHeart as fasHeart, faWindowMinimize, faFileImport, faVenusMars, faImage as fasImage, faThermometerHalf, faComment as fasComment, faUserCheck, faBuilding, faFlag, faRedoAlt as fasRedoAlt, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faYoutube, faTelegramPlane, faTiktok, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faFolderOpen, faHeart, faComment, faPercentage, faAt, faHashtag, faUser as farUser, faFileChartLine, faImages, faInfoCircle, faExclamationCircle as falExclamationCircle, faList as falList, faEnvelope, faCommentAltDots, faTimes as falTimes, faMinus, faDebug,faImagePolaroid, faSlidersH, faUserPlus, faCheck as falCheck, faFileAlt as falFileAlt, faQuestionCircle as falQuestionCircle, faClone as falClone, faSidebarFlip as falSidebarFlip, faArrowUpRightFromSquare as falArrowUpRightFromSquare, faWindowRestore as falWindowRestore, faPlus as falPlus, faTimesCircle as falTimesCircle, faFileCsv as falFileCsv, faBoltAuto as falBoltAuto, faPlusCircle as falPlusCircle, faMinusCircle as falMinusCircle, faThumbsUp as falThumbsUp, faTableCells as falTableCells } from '@fortawesome/pro-light-svg-icons'
import { faList, faFilePdf, faEclipseAlt, faHourglassHalf, faLongArrowLeft, faSyncAlt, faChartBar, faChevronRight, faChevronLeft, faClone as farClone, faPlay as farPlay, faChartLine, faTrashAlt, faHouseUser, faYenSign, faShieldCheck, faRedoAlt, faCog as farCog, faEllipsisH, faCommentAlt , faEnvelope as farEnvelope, faMapMarkerAlt as farMapMarkerAlt, faCommentAltDots as farCommentAltDots, faImagePolaroid as farImagePolaroid, faUserFriends as farUserFriends, faUserCheck as farUserCheck, faFilter, faExternalLink, faSmile as farSmile, faFlag as farFlag, faLink as farLink, faArrowLeft as farArrowLeft, faFileAlt as farFileAlt, faExclamationTriangle as farExclamationTriangle, faArrowTurnDownLeft, faFileImport as farFileImport, faHeart as farHeart, faPercentage as farPercentage, faShareNodes as farShareNodes, faCopy as farCopy, faPen as farPen, faArrowToBottom as farArrowToBottom, faArrowUpRightAndArrowDownLeftFromCenter, faTableCells as farTableCells, faComment as farComment, faRetweet as farRetweet, faSquareQuote as farSquareQuote, faCode as farCode } from '@fortawesome/pro-regular-svg-icons'
import { faSearch, faCloudDownload, faRocketLaunch, faPiggyBank, faCheck, faLayerPlus, faCameraAlt, faAnalytics, faSpinnerThird, faPercentage as fasPercentage, faCircleNotch, faBuildings, faUserGroup, faBolt, faTableCells as fasTableCells, faBadgeCheck, faBrightness as fasBrightness } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import InfiniteLoading from 'vue-infinite-loading'
import VueProgressBar from 'vue-progressbar'
import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import 'firebase/compat/app'
import store from './store'
import VueIntercom from 'vue-intercom'
import VueMq from 'vue-mq'
import VueObserveVisibility from 'vue-observe-visibility'
import draggable from 'vuedraggable'
import { can } from "./utils/acl";
// import axiosCookieJarSupport from 'axios-cookiejar-support';

library.add(fasHeart, faWindowMinimize, faHeart, faQuestionCircle, faFemale, faMale, faTag, faVideo, faComment, faPercentage, faAt, faHashtag, faUser, faFileChartLine, faCheckCircle, faPaperPlane, faStar, faMedal, faArrowUp, faArrowDown, faExclamation, faArrowLeft, faCrown, faFireAlt, faInstagram, faExternalLinkAlt, faLink, faExternalLinkSquareAlt, faCalendarAlt, faReceipt, faBars, faCaretDown, faMapMarkerAlt, faList, faFilePdf, faSearch, faCloudDownload, faRocketLaunch, faPiggyBank, faCheck, faEclipseAlt, faHourglassHalf, faLongArrowLeft, faSyncAlt, faChartBar, faChevronRight, faChevronLeft, faMoon, faFolderOpen, faYoutube, faEye, faThumbsUp, faThumbsDown, faLock ,faClone, farClone, faPlay, faUserFriends, faExclamationCircle, faSmile, faFileAlt, faPlus, faTimesCircle, faPlusCircle, faTimes, faLayerPlus, faCameraAlt, faAnalytics, faSpinnerThird, fasPercentage, farUser, faImages, faInfoCircle, farPlay, faChartLine, faTrashAlt, faHouseUser, faYenSign, faRedoAlt, farCog, faEllipsisH, faCommentAlt, faImagePolaroid, faFileImport, faVenusMars, fasImage, faThermometerHalf, fasComment, faUserCheck, faCog, falExclamationCircle, falList, faEdit, faExclamationTriangle, faTelegramPlane, faEnvelope, faCommentAltDots, farEnvelope, falTimes, faMinus, faDebug, faShieldCheck, farMapMarkerAlt, farCommentAltDots, farImagePolaroid, farUserFriends, farUserCheck, faFilter, faExternalLink, faSlidersH, faUserPlus, farSmile, falCheck, falFileAlt, faBuilding, faFlag, farFlag, fasRedoAlt, farLink, farArrowLeft, farFileAlt, falQuestionCircle, farExclamationTriangle, faArrowTurnDownLeft, faCircleNotch, falClone, faTiktok, farFileImport, farHeart, farPercentage, farShareNodes, falSidebarFlip, falArrowUpRightFromSquare, falWindowRestore, faBuildings, faUserGroup, farCopy, farPen, falPlus, falTimesCircle, farArrowToBottom, faBolt, falFileCsv, falBoltAuto, faArrowUpRightAndArrowDownLeftFromCenter, falPlusCircle, falMinusCircle, falThumbsUp, falTableCells, fasTableCells, farTableCells, faTwitter, faBadgeCheck, farComment, farRetweet,farSquareQuote, farCode, fasBrightness, faArrowRight);

Vue.config.productionTip = false
Vue.use(ElementUI)
locale.use(lang)
Vue.use(VueAxios, axios) //追記
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(InfiniteLoading)
Vue.use(VueProgressBar)
Vue.use(VueIntercom, { appId: 'vg6qifqr' });
Vue.use(VueMq, {
  breakpoints: { // default breakpoints - customize this
    sp: 480,
    tb: 960,
    lg: Infinity,
  },
  defaultBreakpoint: 'sm' // customize this for SSR
})
Vue.use(VueObserveVisibility)
Vue.component('draggable', draggable)
Vue.prototype.$can = (...args) => can(...args)



axiosCancel(axios, {
  debug: false // default
});

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  store,
  el: '#app',
  mounted () {
  },
  async created () {
    try {
        let currentDomain = window.location.hostname

        // APIからOEMの設定を取得
        let baseURL = process.env.VUE_APP_API + '/api/auth/oem'
        let urlWithDomain = `${baseURL}?domain=${encodeURIComponent(currentDomain)}`
        const response = await axios.get(urlWithDomain)

        if (response && response.data && response.data.oem) {
            // リクエストが成功し、OEM設定が存在する場合

            if (response.data.oem.site_name) {
                // レスポンスのsite_nameでtitleを更新する
                document.title = response.data.oem.site_name
            }

            if (response.data.oem.favicon) {
                // レスポンスのfaviconでファビコンリンクを更新する
                const link = document.querySelector('link[rel*="icon"]') || document.createElement('link')
                link.type = 'image/x-icon'
                link.rel = 'shortcut icon'
                link.href = response.data.oem.favicon
                document.getElementsByTagName('head')[0].appendChild(link)
            }
        }
    } catch (err) {
        // Handle error but don't log it to the console
    }
  },
  render: h => h(App),
}).$mount('#app')

